import * as React from 'react';

export interface BaseModalProps {
    show: boolean,
    onClose: () => void,
}

export default abstract class BaseModal<P extends BaseModalProps, S = {}> extends React.Component<P, S> {

}

